import { RequestHandler } from 'apollo-link';
import { createTrackingHeaders } from './createTrackingHeaders';
import { setTags as setSentryTags } from '@sentry/browser';

export const setRequestHeaders: RequestHandler = (operation, forward) => {
  const trackingHeaders = createTrackingHeaders();

  setSentryTags(trackingHeaders);

  operation.setContext({
    headers: {
      ...trackingHeaders,
    },
  });

  return forward(operation);
};
